module.exports = "/images/shoppingenuvem.png?6d9686171051fa58be944ffdcb75bbef";